import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import type * as v from 'valibot';
import { type marketplaceFieldSCSchema } from './schema';

export type MarketplaceFieldProps = StructuredContentDocument<
  v.InferInput<typeof marketplaceFieldSCSchema>
>;

export const MarketplaceField = ({ props }: MarketplaceFieldProps) => {
  return <>{props.marketplaceField?.value}</>;
};
